(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    if (!window.__piqLocalizationCountryLanguageSync) {
    window.__piqLocalizationCountryLanguageSync = true;

    const applyPreferredLanguage = (item) => {
      if (!(item instanceof HTMLElement)) return;

      const component = item.closest('localization-form-component');
      const form = component?.querySelector('form');
      const languageCode = item.dataset.languageCode;

      if (!(form instanceof HTMLFormElement) || !languageCode) return;

      let languageInput = form.querySelector('input[data-preferred-language-sync]');

      if (!(languageInput instanceof HTMLInputElement)) {
        languageInput = document.createElement('input');
        languageInput.type = 'hidden';
        languageInput.name = 'language_code';
        languageInput.dataset.preferredLanguageSync = 'true';
        form.append(languageInput);
      }

      languageInput.value = languageCode;
    };

    document.addEventListener(
      'click',
      (event) => {
        const item =
          event.target instanceof Element
            ? event.target.closest('.localization-form__list-item[data-language-code]')
            : null;
        applyPreferredLanguage(item);
      },
      true
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Enter') return;

        const item =
          document.activeElement instanceof Element
            ? document.activeElement.closest('.localization-form__list-item[data-language-code]')
            : null;
        applyPreferredLanguage(item);
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["piq-cart-gift"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-cart-gift')) {
    customElements.define(
      'piq-cart-gift',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (e) => {
            const b = e.target.closest('.piq-gift__add');
            if (!b || !window.piqAddToCart) return;
            b.disabled = true;
            const item = { id: parseInt(b.dataset.variant, 10), quantity: 1 };
            if (b.dataset.gift) item.properties = { _piq_gift: '1' };
            b.textContent = '…';
            window
              .piqAddToCart([item], { addUrl: this.dataset.addUrl, cartUrl: this.dataset.cartUrl })
              .then(() => {
                b.textContent = '✓';
              })
              .catch((err) => {
                console.error(err);
                b.textContent = '!';
                b.classList.add('is-error');
                setTimeout(() => {
                  b.textContent = '+';
                  b.classList.remove('is-error');
                  b.disabled = false;
                }, 1800);
              });
          });
          this.trimGifts();
        }

        // Zu viele Gratis-Dosen (z. B. nach dem Entfernen von Dosen)? Überzählige automatisch entfernen.
        trimGifts() {
          const allowed = parseInt(this.dataset.allowed || '0', 10);
          const entries = (this.dataset.giftKeys || '')
            .split(',')
            .filter(Boolean)
            .map((e) => {
              const i = e.lastIndexOf(':');
              return { key: e.slice(0, i), qty: parseInt(e.slice(i + 1), 10) || 0 };
            });
          let total = entries.reduce((a, e) => a + e.qty, 0);
          if (total <= allowed || this._trimming) return;
          this._trimming = true;
          const lines = [];
          for (let i = entries.length - 1; i >= 0 && total > allowed; i--) {
            const e = entries[i];
            const cut = Math.min(e.qty, total - allowed);
            lines.push({ id: e.key, quantity: e.qty - cut });
            total -= cut;
          }
          const actions = window.Shopify && window.Shopify.actions;
          if (actions && typeof actions.updateCart === 'function') {
            actions.updateCart({ lines }, { event: { context: 'cart' } }).catch((err) => console.error(err));
          } else {
            const updates = {};
            lines.forEach((l) => (updates[l.id] = l.quantity));
            fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            }).then(() => window.location.reload());
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["piq-cart-rewards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-rewards')) {
    customElements.define(
      'piq-rewards',
      class extends HTMLElement {
        connectedCallback() {
          const tier = parseInt(this.dataset.tier || '0', 10) || 0;
          let last = 0;
          try {
            last = parseInt(sessionStorage.getItem('piq-tier') || '0', 10) || 0;
            sessionStorage.setItem('piq-tier', String(tier));
          } catch (e) {}
          if (tier > last) this.celebrate();
        }

        celebrate() {
          const yay = this.querySelector('.piq-rewards__yay');
          if (yay) {
            yay.textContent = this.dataset.yay;
            yay.hidden = false;
          }
          this.classList.add('is-celebrating');
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          const colors = [getComputedStyle(this).getPropertyValue('--piq-accent').trim() || '#04bff5', '#ffca01', '#df3f4c', '#1f9d55', '#111'];
          for (let i = 0; i < 22; i++) {
            const p = document.createElement('span');
            p.className = 'piq-confetti';
            const a = (Math.PI * 2 * i) / 22 + Math.random() * 0.4;
            const d = 60 + Math.random() * 70;
            p.style.setProperty('--x', Math.cos(a) * d + 'px');
            p.style.setProperty('--y', Math.sin(a) * d - 20 + 'px');
            p.style.setProperty('--r', Math.random() * 540 - 270 + 'deg');
            p.style.background = colors[i % colors.length];
            this.appendChild(p);
            setTimeout(() => p.remove(), 1100);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["piq-geo-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-geo-banner')) {
    customElements.define(
      'piq-geo-banner',
      class extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;
          let dismissed = false;
          try {
            dismissed = localStorage.getItem('piq-geo-dismissed') === '1' || sessionStorage.getItem('piq-geo-seen') === '1';
          } catch (e) {}
          if (dismissed) return;
          let countries = {};
          try {
            countries = JSON.parse(this.querySelector('[data-countries]').textContent);
          } catch (e) {
            return;
          }
          const current = this.dataset.current;
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(current))
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => {
              if (!data) return;
              const detected = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
              if (!detected || detected === current || !countries[detected]) return;
              this.show(detected, countries[detected]);
            })
            .catch(() => {});
        }

        show(code, c) {
          this.querySelector('[data-text]').textContent = this.dataset.q.split('[c]').join(c.name);
          const flag = this.querySelector('.piq-geo__flag');
          if (c.flag) {
            flag.src = c.flag;
            flag.hidden = false;
          }
          const form = this.querySelector('form');
          this.querySelector('[data-yes]').addEventListener('click', () => {
            form.elements['country_code'].value = code;
            form.elements['language_code'].value = c.lang;
            form.submit();
          });
          this.querySelector('[data-no]').addEventListener('click', () => {
            try {
              localStorage.setItem('piq-geo-dismissed', '1');
            } catch (e) {}
            this.hidden = true;
          });
          try {
            sessionStorage.setItem('piq-geo-seen', '1');
          } catch (e) {}
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["piq-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-localization')) {
    customElements.define(
      'piq-localization',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          // Beim Zurückspringen (Browser-Cache) Ladezustand zurücksetzen, sonst sind die Buttons gesperrt
          this.classList.remove('is-loading');
          this._onShow = this._onShow || (() => this.classList.remove('is-loading'));
          window.addEventListener('pageshow', this._onShow);
          if (this._bound) return;
          this._bound = true;
          this.addEventListener('click', (e) => {
            const t = e.target.closest('[data-country][data-language]');
            if (!t || !this.form) return;
            e.preventDefault();
            if (this.classList.contains('is-loading')) return;
            if (t.getAttribute('aria-current') === 'true') {
              // Bereits gewählt: nur das Fenster schließen
              const dd = this.closest('dropdown-localization-component');
              if (dd && typeof dd.hidePanel === 'function') dd.hidePanel();
              const det = this.closest('details');
              if (det) det.open = false;
              return;
            }
            this.form.elements['country_code'].value = t.dataset.country;
            this.form.elements['language_code'].value = t.dataset.language;
            this.classList.add('is-loading');
            this.form.submit();
          });
        }
        focusSearchInput() {}
        disconnectedCallback() {
          window.removeEventListener('pageshow', this._onShow);
        }
        resetForm() {}
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["piq-page-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    const dlg = document.getElementById('piq-page-popup');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const handle = dlg.dataset.handle;
    const re = new RegExp('/pages/' + handle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '/?$');
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || a.hasAttribute('data-piq-pp-skip')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      let path;
      try {
        path = new URL(a.href, location.href).pathname;
      } catch (err) {
        return;
      }
      if (!re.test(path)) return;
      e.preventDefault();
      dlg.showModal();
    });
    dlg.addEventListener('click', (e) => {
      if (e.target.closest('[data-piq-pp-close]') || e.target === dlg) dlg.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["piq-tiers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-card-tiers')) {
    class PiqCardTiers extends HTMLElement {
      connectedCallback() {
        this.tiers = Array.from(this.querySelectorAll('.piq-ct__tier'));
        this.addBtn = this.querySelector('button.piq-ct__add');
        this.labelEl = this.querySelector('[data-ct-label]');
        this.shortEl = this.querySelector('[data-ct-short]');
        if (!this.addBtn) return;
        this.tiers.forEach((t) =>
          t.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.select(t);
          })
        );
        this.addBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.add();
        });
        this.qty = 1;
        const first = this.querySelector('.piq-ct__tier.is-active') || this.tiers.find((t) => !t.disabled) || this.tiers[0];
        if (first) this.select(first);
        else {
          const one = this.money(parseFloat(this.dataset.price));
          if (this.labelEl) this.labelEl.textContent = `${this.dataset.label} · ${one}`;
          if (this.shortEl) this.shortEl.textContent = one;
        }
      }

      money(cents) {
        return new Intl.NumberFormat(this.dataset.locale || 'de-DE', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR'
        }).format(cents / 100);
      }

      select(tier) {
        if (!tier) return;
        this.tiers.forEach((t) => {
          t.classList.toggle('is-active', t === tier);
          t.setAttribute('aria-checked', t === tier ? 'true' : 'false');
        });
        this.qty = parseInt(tier.dataset.qty, 10) || 1;
        const disc = parseFloat(tier.dataset.disc) || 0;
        const price = parseFloat(this.dataset.price);
        const total = (price - Math.floor(price * disc / 100)) * this.qty;
        if (this.labelEl) this.labelEl.textContent = `${this.dataset.label} · ${this.money(total)}`;
        if (this.shortEl) this.shortEl.textContent = this.money(total);
      }

      add() {
        const label = this.labelEl ? this.labelEl.textContent : '';
        const short = this.shortEl ? this.shortEl.textContent : '';
        const set = (l, sh) => {
          if (this.labelEl) this.labelEl.textContent = l;
          if (this.shortEl) this.shortEl.textContent = sh;
        };
        this.addBtn.disabled = true;
        set(this.dataset.adding, '…');
        window
          .piqAddToCart([{ id: parseInt(this.dataset.variant, 10), quantity: this.qty }], {
            addUrl: this.dataset.addUrl,
            cartUrl: this.dataset.cartUrl
          })
          .then(() => {
            this.addBtn.classList.add('is-added');
            set('✓ ' + this.dataset.added, '✓');
            setTimeout(() => {
              this.addBtn.classList.remove('is-added');
              set(label, short);
            }, 1600);
          })
          .catch((err) => {
            console.error(err);
            set(label, short);
          })
          .finally(() => {
            this.addBtn.disabled = false;
          });
      }
    }
    customElements.define('piq-card-tiers', PiqCardTiers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["piq-trust-row"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('piq-eta')) {

    customElements.define(
      'piq-eta',

      class extends HTMLElement {

        connectedCallback() {

          const nums = (this.dataset.days || '').match(/\d+/g);

          if (!nums) return;

          const min = parseInt(nums[0], 10);
          const max = parseInt(nums[nums.length - 1], 10);
          const cutoff = parseInt(this.dataset.cutoff || '14', 10);
          const wd = (this.dataset.wd || '').split(',');

          const now = new Date();

          // Nach Versandschluss oder am Wochenende startet die Zählung am nächsten Werktag
          let extra = now.getHours() >= cutoff ? 1 : 0;

          const addBusinessDays = (n) => {

            const d = new Date(now);

            let added = 0;

            while (added < n) {

              d.setDate(d.getDate() + 1);

              const day = d.getDay();

              if (day !== 0 && day !== 6) {
                added++;
              }

            }

            return d;
          };

          const fmt = (d) =>
            `${wd[d.getDay()] || ''} ${String(d.getDate()).padStart(2, '0')}.${String(
              d.getMonth() + 1
            ).padStart(2, '0')}.`;

          const a = addBusinessDays(min + extra);
          const b = addBusinessDays(max + extra);

          const out = this.querySelector('[data-eta]');

          if (out) {
            out.textContent =
              min === max
                ? fmt(a)
                : `${fmt(a)} ${this.dataset.to || '-'} ${fmt(b)}`;
          }

          this.hidden = false;
        }

      }
    );

  }
  } catch(e) { console.error(e); }
})();

})();
